import { createSharedComposable } from '@vueuse/core';
import { ref } from 'vue';

/**
 * TRIZ 应用的轻量级共享状态
 */
export const useTrizState = createSharedComposable(() => {
    // TRIZ 任务标题
    const trizTitle = ref<string>('');

    // 是否显示右侧详情面板
    const openDetail = ref(false);

    // 用户是否手动关闭过详情面板，关闭后不再自动打开
    const userClosedDetail = ref(false);

    /**
     * 更新详情面板显示状态
     */
    function updateOpenDetail(value: boolean) {
        openDetail.value = value;
    }

    /**
     * 用户手动关闭详情面板，后续不再自动打开
     */
    function closeDetailByUser() {
        userClosedDetail.value = true;
        openDetail.value = false;
    }

    /**
     * 更新 TRIZ 标题
     */
    function updateTrizTitle(value: string) {
        trizTitle.value = value;
    }

    return {
        trizTitle,
        openDetail,
        userClosedDetail,
        updateOpenDetail,
        closeDetailByUser,
        updateTrizTitle,
    };
});
